export default __webpack_public_path__ + "static/media/hall_of_fame_bg_rigth.8ac49fdd.png";